// Configure jQuery
import jQuery from "jquery"
window.jquery = jQuery
window.jQuery = jQuery
window.$ = jQuery
